import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa enseñando online?',
  a: 'No. El sistema está diseñado para guiarte paso a paso, incluso si nunca has dado una clase por internet o no sabes usar herramientas digitales complejas.'
}, {
  q: '¿Cuánto tiempo tengo para acceder al material?',
  a: 'El acceso es de por vida. Pagas una sola vez y puedes acceder al Megapack y todas sus futuras actualizaciones para siempre.'
}, {
  q: '¿Funciona si tengo pocos seguidores?',
  a: 'Sí. Te enseñamos estrategias probadas para atraer alumnos interesados sin necesidad de ser un influencer o tener miles de seguidores en redes sociales.'
}, {
  q: '¿Qué pasa si no me funciona?',
  a: 'Tienes nuestra garantía de 45 días. Si aplicas el sistema y sientes que no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Cómo recibo el producto?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso a nuestra plataforma privada donde está todo el material.'
}, {
  q: '¿Puedo pagar con tarjeta?',
  a: 'Sí, aceptamos todas las tarjetas de crédito y débito principales, además de otros métodos de pago locales dependiendo de tu país.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-65">
      <div className="text-center mb-12" data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-67">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="space-y-4" data-id="element-68">
        {faqs.map((faq, i) => <div key={i} className="glass-card rounded-xl overflow-hidden border border-white/10" data-id="element-69">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-70">
              <span className="text-lg font-medium text-white" data-id="element-71">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-72" />
            </button>

            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-73">
              <p className="text-gray-300" data-id="element-74">{faq.a}</p>
            </div>
          </div>)}
      </div>
    </section>;
}